module.exports = __webpack_public_path__ + "static/logo_negro-882b5692b6761b5e115f7d85117639cf.svg";